import React from 'react';

import * as S from '../styles';
import { getHelperTextType } from '../types';

const HelperText = ({
    errorStatus,
    successStatus,
    touched,
    helperMessage,
    errorMessage,
    successMessage,
}: getHelperTextType) => {
    let message = helperMessage;

    if (touched) {
        if (errorStatus) {
            message = errorMessage;
        }

        if (successStatus) {
            message = successMessage;
        }
    }

    const successColors = successStatus ? 'success-default' : 'text-secondary-subdued';
    const helperTextColor = errorStatus ? 'critical-default' : successColors;

    return (
        <S.HelperText bold type="caption" color={helperTextColor} dataLocator="inputInfoText">
            {message}
        </S.HelperText>
    );
};

export default HelperText;
